export default __webpack_public_path__ + "static/media/local.ea4efbc0.jpeg";